{
    "main_h1": "Neuigkeiten aus und für Zürich",
    "date_published": "Veröffentlicht",
    "date_modified": "Letze Aktualisierung",
    "back_to_feed": "Zurück zur Übersicht",
    "PROMOTION": "Promotion",
    "SOCIETY": "Gesellschaft",
    "FREETIME": "Freizeit",
    "NEWS": "Akuelles"
}